<template>
  <v-card class="pa-5 main-grid">
    <v-toolbar flat dense>
      <v-btn icon to="/">
        <v-icon large>mdi-keyboard-backspace</v-icon>
      </v-btn>
    </v-toolbar>
    <v-form ref="mci">
      <v-row
        ><v-text-field
          v-model="mci"
          :rules="[v => !!v || 'MCI is required']"
          class="mx-3"
          style="max-width: 400px"
          label="Document Number (MCI or SAP)"
        >
        </v-text-field
      ></v-row>
    </v-form>
    <v-row>
      <v-spacer></v-spacer>
      <v-btn class="mr-4" color="success" @click.stop="submitMci">Submit</v-btn>
    </v-row>
  </v-card>
</template>

<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
import router from '../router';

export default {
  directives: { mask },
  data() {
    return {
      mci: '',
      mciMask: '####-####',
      document: {}
    };
  },
  methods: {
    submitMci() {
      if (this.$refs.mci.validate()) {
        axios.get('/Document/DocumentByMCI/' + this.mci).then(response => {
          if (response.data !== '') {
            // this.document = response.data;
            router.push({
              name: 'modify',
              params: {
                id: response.data.id
              }
            });
          } else {
            router.push({
              name: 'create',
              params: {
                mci: this.mci
              }
            });
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.main-grid {
  min-width: 100%;
}
</style>
